import { Box, Button, Link, Typography } from '@mui/material';
import classNames from 'classnames';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { BreakTimer } from 'modules/bracket/components/BreakTimer';
import { tournamentActivitySelector } from 'modules/tournament-activity/store/selectors';
import { useStyles } from '../../styles/TournamentGameActivity.styles';

interface NextTournamentGameProps {
  onTournamentClick: () => void;
}

export const NextTournamentGame: FC<NextTournamentGameProps> = ({ onTournamentClick }) => {
  const { classes } = useStyles();

  const name = useSelector(tournamentActivitySelector.name);
  const tournamentActivity = useSelector(tournamentActivitySelector.activity);
  const timerDuration = useSelector(tournamentActivitySelector.timerDuration);
  const timerStartedAt = useSelector(tournamentActivitySelector.timerStartedAt);

  if (!tournamentActivity?.activity?.startedAt) {
    return null;
  }

  return (
    <Box className={classes.root}>
      <Box className={classes.container}>
        <Typography className={classes.lineClampText}>
          <Link onClick={onTournamentClick}>{name}</Link>
          <Typography component="span" pr={0.5} pl={0.5}>
            -
          </Typography>
          <Typography component="span">You Are on a Break</Typography>
        </Typography>
        <Button disabled color="primary" variant="contained" className={classNames(classes.button)}>
          <Typography className={classes.buttonText}>
            <BreakTimer
              prefix="Next Match in"
              startedAt={timerStartedAt}
              duration={timerDuration}
            />
          </Typography>
        </Button>
      </Box>
    </Box>
  );
};
